var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dls"},[(_vm.isLogin)?_c('div',{staticClass:"ilsogin"},[_c('keep-alive',[_c('router-view',{on:{"handleTKD":_vm.handleBanner}})],1)],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }